import z from 'zod';

export const USER_ROLE = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  USER: 'USER',
} as const;

export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export const userScheme = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  avatar_url: z.string().optional().nullable(),
  is_confirmed: z.boolean(),
  role: z.nativeEnum(USER_ROLE),
  last_login_at: z.string().nullable(),
  created_at: z.string(),
});

export type User = z.infer<typeof userScheme>;
